import { SapC4CCopySource } from './../../../pipeline/copysource/sapc4c.copysource';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from '../../value.adapter';
import { stringIsNullOrEmpty } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapC4CCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        httpRequestTimeout: '*'
    }
})
export class SapC4CCopySourceAdapter extends CopySourceAdapter<SapC4CCopySource, Model.SapCloudForCustomerSource> {
    protected override async _toResource(copySource: SapC4CCopySource): Promise<Model.SapCloudForCustomerSource> {
        const result = this._toTabularResource(copySource, Metamodel.modelFor(SapC4CCopySource).name);
        result.httpRequestTimeout = ValueAdapter.toResource(copySource, SapC4CCopySource.HTTP_REQUEST_TIMEOUT);
        // clear out '' from resource, backend doesn't support ''
        if (stringIsNullOrEmpty(result.httpRequestTimeout)) {
            result.httpRequestTimeout = undefined;
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.SapCloudForCustomerSource,
        copyActivity: CopyActivity
    ): Promise<SapC4CCopySource> {
        const result: SapC4CCopySource = this._toTabularModel(resource, copyActivity, SapC4CCopySource.MODEL);
        if (resource.httpRequestTimeout != null) {
            ValueAdapter.toModel(result, SapC4CCopySource.HTTP_REQUEST_TIMEOUT, resource.httpRequestTimeout);
        } else {
            // clear default value for all existing resources
            result.httpRequestTimeout = undefined;
        }
        return result;
    }
}
